import { render, staticRenderFns } from "./MatchReview.vue?vue&type=template&id=a4094644&scoped=true&"
import script from "./MatchReview.vue?vue&type=script&lang=js&"
export * from "./MatchReview.vue?vue&type=script&lang=js&"
import style0 from "./MatchReview.vue?vue&type=style&index=0&id=a4094644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4094644",
  null
  
)

export default component.exports